<div class="change-password-modal-form-wrapper">
  <form class="form" [formGroup]="form" autocomplete="off">
    <!--new password-->
    <app-form-input-password [field]="'passNew'" [formControl]="f['passNew']" [feedback]="false"
                             formControlName="passNew"></app-form-input-password>
    <!--new password repeat-->
    <app-form-input-password [field]="'passNewRepeat'" [formControl]="f['passNewRepeat']" [feedback]="false"
                             formControlName="passNewRepeat"></app-form-input-password>
    <!--buttons-->
    <div class="buttons">
      <p-button label="{{'button.cancel' | translate | uppercase}}" styleClass="p-button-sm"
                [disabled]="loading" [outlined]="true" (click)="cancel()"></p-button>
      <p-button label="{{'button.save' | translate | uppercase}}" styleClass="p-button-sm"
                [loading]="loading" (click)="save()"></p-button>
    </div>
  </form>
</div>
